import React from "react";
import "./Footer.scss";
import logo from "../../assets/logo-white.svg";
import credits from "../../assets/credits.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__main">
          {/* Logo e Indirizzo */}
          <div className="footer__brand">
            <a href="/" className="footer__logo">
              <img src={logo} alt="Stucchi Logo" />
            </a>
            <address className="footer__address">
              <span className="footer__address-company">Stucchi Spa</span>
              <br />
              Via della Lira Italiana, 397
              <br />
              24040 - Pagazzano (BG)
              <br />
              Italy
            </address>
          </div>

          {/* Colonna Prodotti */}
          <div className="footer__column">
            <h3 className="footer__title">Products</h3>
            <nav className="footer__nav">
              <a
                href="https://www.stucchigroup.com/innesti-rapidi/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Couplings
              </a>
              <a
                href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=multinnesti"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Multicouplings
              </a>
              <a
                href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=monoblocco"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Castings
              </a>
              <a
                href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=serie-speciali"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Special Series
              </a>
              <a
                href="https://www.stucchigroup.com/innesti-rapidi/?famiglia[]=prodotti-complementari"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Complementary Products
              </a>
            </nav>
          </div>

          {/* Colonna Azienda */}
          <div className="footer__column">
            <h3 className="footer__title">Company</h3>
            <nav className="footer__nav">
              <a
                href="https://www.stucchigroup.com/chi-siamo/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Company
              </a>
              <a
                href="https://www.stucchigroup.com/storia/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                History
              </a>
              <a
                href="https://www.stucchigroup.com/codice-etico/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Code of Ethics and MOGC
              </a>
              <a
                href="https://www.stucchigroup.com/certifications/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Quality, Environment, Safety
              </a>
              <a
                href="https://www.stucchigroup.com/stucchi-nel-mondo/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stucchi in the world
              </a>
              <a
                href="https://www.stucchigroup.com/tour-aziendale/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Virtual Tour
              </a>
            </nav>
          </div>

          {/* Colonna Stucchi */}
          <div className="footer__column">
            <h3 className="footer__title">Stucchi</h3>
            <nav className="footer__nav">
              <a
                href="https://www.stucchigroup.com/support-tools/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Support Tools
              </a>
              <a
                href="https://www.stucchigroup.com/news/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                News
              </a>
              <a
                href="https://www.stucchigroup.com/lavora-con-noi/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Careers
              </a>
              <a
                href="https://www.stucchigroup.com/downloads/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </a>
              <a
                href="https://www.stucchigroup.com/contatti/"
                className="footer__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contacts
              </a>
            </nav>
          </div>

          {/* Colonna Newsletter e Social */}
          <div className="footer__column footer__column--right">
            <div className="footer__newsletter">
              <h3 className="footer__title">Newsletter</h3>
              <a
                href="https://www.stucchigroup.com/newletter/"
                className="footer__newsletter-btn"
                aria-label="Subscribe to newsletter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10H16M16 10L11 5M16 10L11 15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>

            <div className="footer__social">
              <a
                href="https://www.linkedin.com/company/stucchi-quick-couplings"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-icon"
                aria-label="LinkedIn"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/c/Stucchiquickcouplings"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-icon"
                aria-label="YouTube"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/stucchi_quickcouplings/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-icon"
                aria-label="Instagram"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer__bottom">
          <div className="footer__legal">
            N.R.I. di Bergamo - Cod. Fiscale/Reg. Imprese: 00724900162 - VAT Nr:
            IT 00724900162 - Share Cap. Soc. 6.000.000 euro - Pec: stucchispa at
            pec.it
          </div>

          <div className="footer__right">
            <div className="footer__links">
              <a
                href="https://www.stucchigroup.com/note-legali/"
                className="footer__link-small"
                target="_blank"
                rel="noopener noreferrer"
              >
                Legal Notes
              </a>
              <a
                href="https://www.stucchigroup.com/cookie-policy/"
                className="footer__link-small"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cookie Policy
              </a>
              <a
                href="https://www.stucchigroup.com/privacy-policy/"
                className="footer__link-small"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>

            <div className="footer__bespoken">
              <a
                href="https://www.bspkn.it/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Bespoken"
              >
                <img src={credits} alt="Bespoken" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
